import { Button, Divider } from "antd";
import { Link } from "react-router-dom";
import styles from "../CartCheckout.module.scss";
import { AuthModalContext } from "../../../Contexts/AuthModalContext";
import { useContext } from "react";

export const CartCheckoutEmptyState = ({ isAuthenticated }) => {
  const { openSignIn, openRegister } = useContext(AuthModalContext);

  return (
    <div className={styles.empty_cart}>
      <img
        src="https://desi-fresh.b-cdn.net/components_static/empty-cart.svg"
        alt="empty-cart"
      />
      <br />
      {isAuthenticated ? (
        <b>Your Cart is empty!</b>
      ) : (
        <b>Sign in to see your saved items.</b>
      )}
      <br />
      {!isAuthenticated && (
        <>
          <Button
            size={"large"}
            style={{ padding: "0 8rem" }}
            type={"primary"}
            onClick={() => openSignIn()}
          >
            Sign In
          </Button>
          <br />
          <span>
            Don't have an account?{" "}
            <span
              role="button"
              style={{
                color: "var(--color-primary)",
                fontWeight: "bold",
                textDecoration: "underline",
                cursor: "pointer",
              }}
              onClick={() => openRegister()}
            >
              Register Now
            </span>{" "}
          </span>
          <br />
          <span>
            See our{" "}
            <Link
              style={{
                color: "var(--color-primary)",
                fontWeight: "bold",
                textDecoration: "underline",
              }}
              to={"/data-protection"}
            >
              Privacy Policy
            </Link>{" "}
          </span>
        </>
      )}
      <Divider style={{ maxWidth: "500px" }} />
      <p
        style={{
          fontSize: "2.8rem",
          color: "var(--color-primary)",
          fontWeight: "bold",
        }}
      >
        Shop Now, Make a Difference!
      </p>
    </div>
  );
};
